/* Live book offer: uses the saved native Shopify template and native customer POST. */
(() => {
  'use strict';
  const loader = document.getElementById('clp-book-offer-loader');
  if (!loader || loader.dataset.initialized || window.Shopify?.designMode) return;
  loader.dataset.initialized = 'true';
  const params = new URLSearchParams(location.search);
  if (params.get('gallery_popup') === 'preview') return;
  const preview = params.get('book_popup') === 'preview';
  const manual = params.get('book_popup') === 'open';
  const coarse = matchMedia('(hover: none), (pointer: coarse)').matches;
  const keys = {
    shown: 'clp-book-preview-shown-this-session',
    dismiss: 'clp-book-preview-dismiss-until',
    pending: 'clp-book-preview-submission-pending',
    subscribed: 'clp-book-preview-confirmed-subscriber',
    policy: 'clp-book-preview-repeat-policy',
  };
  const shared = { shown: 'clp-newsletter-popup-shown-this-session', until: 'clp-newsletter-popup-shown-until' };
  const day = 24 * 60 * 60 * 1000;
  const read = (kind, key) => { try { return window[kind].getItem(key); } catch (_) { return null; } };
  const write = (kind, key, value) => { try { window[kind].setItem(key, String(value)); } catch (_) {} };
  const remove = (kind, key) => { try { window[kind].removeItem(key); } catch (_) {} };
  const returnState = document.getElementById('clp-book-offer-return-state')?.content;
  const returnError = returnState?.querySelector('[data-bop-return-error]');
  const pending = Number(read('sessionStorage', keys.pending));
  const pendingAge = Date.now() - pending;
  const pendingValid = pending > 0 && pendingAge >= 0 && pendingAge < 15 * 60 * 1000;
  const returning = !preview && pendingValid && Boolean(returnError);
  // A button click or pending submission never establishes subscriber status.
  if (!preview && pendingValid && returnState?.querySelector('[data-bop-return-success]')) {
    write('localStorage', keys.subscribed, 'true');
    remove('sessionStorage', keys.pending);
  } else if (!preview && pending && !pendingValid) {
    remove('sessionStorage', keys.pending);
  }
  if (!preview) {
    // Preserve the original display time when upgrading either legacy popup's cap.
    const legacy = [
      [keys.dismiss, keys.policy, 2],
      ['clp-gallery-invitation-dismiss-until', 'clp-gallery-invitation-repeat-policy', read('localStorage', 'clp-gallery-invitation-repeat-policy') === '3-days' ? 2 : 13],
    ];
    let until = Number(read('localStorage', shared.until)) || 0;
    legacy.forEach(([dismissKey, policyKey, daysToRemove]) => {
      let expiry = Number(read('localStorage', dismissKey)) || 0;
      if (read('localStorage', policyKey) !== 'one-day') {
        if (expiry > 0) { expiry -= daysToRemove * day; write('localStorage', dismissKey, expiry); }
        write('localStorage', policyKey, 'one-day');
      }
      until = Math.max(until, expiry);
    });
    if (until > Date.now()) write('localStorage', shared.until, until);
    if (read('sessionStorage', keys.shown) === 'true') write('sessionStorage', shared.shown, 'true');
  }
  // Any signup or message on either cerjlalonde.com site counts (cookie/flag set by clp-book-offer-loader).
  const siteSubscribed = () => read('localStorage', 'clp-site-subscribed') === 'true' || /(?:^|;\s*)(clp_subscribed=1|omnisend-form-[0-9a-f]{24}-filled-at=)/.test(document.cookie) || params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true';
  const knownSubscriber = () => loader.dataset.subscribed === 'true' || siteSubscribed() || read('localStorage', keys.subscribed) === 'true' || read('localStorage', 'clp-gallery-newsletter-subscribed') === 'true';
  // Own cap: at most once per visit and once per 24 hours; the homepage welcome popup no longer blocks it.
  const suppressed = () => !preview && !manual && !returning && (knownSubscriber() || read('sessionStorage', keys.shown) === 'true' || Number(read('localStorage', keys.dismiss)) > Date.now());
  if (loader.dataset.auto === 'false' && !preview && !manual && !returning) return;
  // Homepage too (Cerj, 2026-10-02): a last chance when leaving, after the welcome popup — never while it is
  // open (busy() waits), and once this has shown, the welcome popup stays away for the rest of this page view.
  if (suppressed()) return;
  let dialog, form, mounted, previousFocus, previousOverflow, armed = false, opened = false, opening = false;

  function busy() {
    if (document.hidden) return true;
    const active = document.activeElement;
    if (active && (/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) || active.isContentEditable)) return true;
    return Array.from(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')).some(element => element !== dialog && element.getClientRects().length > 0);
  }

  function stylesheet() {
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = loader.dataset.css;
      link.onload = resolve;
      link.onerror = () => reject(new Error('Book popup style unavailable'));
      document.head.append(link);
    });
  }

  function prepare() {
    if (mounted) return mounted;
    mounted = (async () => {
      const response = await fetch(loader.dataset.source, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Book popup unavailable');
      const source = new DOMParser().parseFromString(await response.text(), 'text/html');
      const popup = source.querySelector('[data-bop-live-source]');
      const blockStyles = source.querySelector('style[data-bop-block-styles]');
      if (!popup || !popup.querySelector('form') || !popup.querySelector('[data-bop-email]') || !popup.querySelector('[data-bop-submit]')) throw new Error('Incomplete book popup');
      await stylesheet();
      dialog = document.createElement('dialog');
      dialog.className = 'clp-book-offer-dialog';
      dialog.setAttribute('aria-label', popup.getAttribute('aria-label') || 'Book preview');
      dialog.lang = popup.dataset.bopLanguage || document.documentElement.lang;
      dialog.style.setProperty('--bop-width', popup.style.getPropertyValue('--bop-width') || '1040px');
      if (typeof dialog.showModal !== 'function') throw new Error('Dialog unavailable');
      if (blockStyles) dialog.append(document.importNode(blockStyles, true));
      const content = document.importNode(popup, true);
      content.hidden = false;
      dialog.append(content);
      document.body.append(dialog);
      form = dialog.querySelector('form');
      const inputs = Array.from(form.querySelectorAll('[data-bop-email]'));
      const address = form.querySelector('[data-bop-email-value]');
      if (returning) {
        const email = returnState.querySelector('[data-bop-return-email]')?.value || '';
        inputs.forEach(input => { input.value = email; });
        form.querySelector('.bop-copy').prepend(document.importNode(returnError, true));
      }
      // Keep native validation active before Shopify's CAPTCHA submit hook runs.
      inputs.forEach(input => { input.required = input === address; });
      // Duplicated email blocks are editable visual mirrors of one signup address.
      inputs.forEach(input => input.addEventListener('input', () => {
        address.value = input.value.trim();
        inputs.forEach(other => { other.setCustomValidity(''); if (other !== input) other.value = input.value; });
      }));
      inputs.forEach(input => input.addEventListener('invalid', () => {
        input.setCustomValidity('');
        if (input.validity.valueMissing) input.setCustomValidity(input.dataset.bopRequiredMessage || '');
        else if (input.validity.typeMismatch) input.setCustomValidity(input.dataset.bopInvalidMessage || '');
      }));
      form.querySelectorAll('[data-bop-submit]').forEach(button => button.addEventListener('click', () => {
        const value = inputs.find(input => input.value.trim())?.value.trim() || '';
        inputs.forEach(input => { input.value = value; });
        address.value = value;
        if (!preview && form.checkValidity()) {
          write('sessionStorage', keys.pending, Date.now());
          const progress = form.querySelector('[data-bop-progress-message]');
          if (progress) progress.hidden = false;
        }
      }, true));
      form.addEventListener('submit', event => {
        if (preview) { event.preventDefault(); return; }
        const value = inputs.find(input => input.value.trim())?.value.trim() || '';
        inputs.forEach(input => { input.value = value; input.required = true; });
        address.value = value;
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        const destination = event.submitter?.dataset.bopReturnTo;
        if (destination) {
          let target = form.querySelector('input[name="return_to"]');
          if (!target) { target = document.createElement('input'); target.type = 'hidden'; target.name = 'return_to'; form.append(target); }
          target.value = destination;
        }
        write('sessionStorage', keys.pending, Date.now());
        // Leave POST, validation challenges, and the real success redirect to Shopify.
      }, true);
      if (preview) {
        form.querySelectorAll('[data-bop-submit]').forEach(button => { button.disabled = true; button.setAttribute('aria-disabled', 'true'); });
        form.querySelector('[data-bop-preview-message]').hidden = false;
      } else if (typeof window.Shopify?.captcha?.protect === 'function') {
        // Shopify documents this hook for forms inserted after DOMContentLoaded.
        window.Shopify.captcha.protect(form);
      }
      const close = () => { if (dialog.open) dialog.close(); };
      dialog.querySelectorAll('[data-bop-close]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow || '';
        // The daily limit starts when shown, not when dismissed.
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      });
      return dialog;
    })();
    return mounted;
  }

  async function open() {
    if (opened || opening || suppressed() || (!preview && !returning && busy())) return;
    opening = true;
    try {
      await prepare();
      if (document.hidden || suppressed() || (!preview && !returning && busy())) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      opened = true;
      loader.dataset.shownThisPage = 'true';
      if (!preview && !returning) {
        write('sessionStorage', keys.shown, 'true');
        write('localStorage', keys.dismiss, Date.now() + day);
      }
      if (returning) {
        remove('sessionStorage', keys.pending);
        dialog.querySelector('[data-bop-return-error]').focus({ preventScroll: true });
      } else {
        dialog.querySelector('[data-bop-close]').focus({ preventScroll: true });
      }
    } catch (_) {
      // Never interrupt shopping or invent a successful signup if loading fails.
    } finally { opening = false; }
  }

  if (preview || manual || returning) {
    open();
    return;
  }
  // "Before you go" opens only when the visitor leaves the page — never on a timer (Cerj, 2026-10-01).
  // Computer: the mouse leaves through the top of the window (toward tabs, address bar, back or close).
  document.addEventListener('pointermove', event => { if (event.clientY > 50) armed = true; }, { passive: true });
  // relatedTarget is null only when the pointer leaves the page itself; a fast real mouse can report up to ~40 px.
  document.addEventListener('mouseout', event => {
    if (!coarse && armed && !event.relatedTarget && event.clientY < 40) open();
  });
  // Phone/tablet: leaving is the Back button or back-swipe. On the first tap (browsers only honour history
  // entries added during a user gesture) one same-URL entry is added; the first Back then opens the popup
  // instead of leaving, and the next Back leaves normally. Never added once the popup is used up.
  if (coarse) {
    let trapped = false;
    const trap = () => {
      if (trapped || opened || suppressed()) return;
      try {
        history.pushState(Object.assign({}, history.state, { clpBookExit: true }), '', location.href);
        trapped = true;
      } catch (_) {}
    };
    document.addEventListener('touchend', trap, { passive: true });
    document.addEventListener('click', trap, { passive: true });
    window.addEventListener('popstate', event => {
      if (!trapped || (event.state && event.state.clpBookExit)) return;
      trapped = false;
      // If the popup cannot show (already used, signed up, busy), let the visitor leave as intended.
      if (suppressed()) { history.back(); return; }
      open().then(() => { if (!opened) history.back(); });
    });
  }
  // Prepare before exit intent without displaying or submitting anything.
  setTimeout(() => { if (!suppressed()) prepare().catch(() => {}); }, 1200);
})();
